<template>
  <div style="margin-top:25px">
    <b-row>
      <b-col>
        <h5>
          Provider Site :
          <span v-if="siteURL">
            <b-link @click="handleGoToSite">
              {{siteURL}}
            </b-link>
          </span>
          <span v-else>
            Not Set
          </span>
        </h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8">
        <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000"
            fade
            indicators
            img-width="1024"
            img-height="480"
        >
          <b-carousel-slide
              caption="First Slide"
              img-src="@/assets/providers/site1.jpg"
          ></b-carousel-slide>
          <b-carousel-slide
              caption="Second Slide"
              img-src="@/assets/providers/site1.jpg"
          ></b-carousel-slide>
          <b-carousel-slide
              caption="Third Slide"
              img-src="@/assets/providers/site3.png"
          ></b-carousel-slide>
        </b-carousel>
      </b-col>
      <b-col md="4">
        <toggles-form
            :data-array="toggles"
            @toggles-change="handleToggleChange"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TogglesForm from "@/components/forms/togglesForm";
export default {
  name: "Admin_Manage_Provider_Site",
  components: {
    TogglesForm
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    myApps(){
      return this.provider && this.provider.myApps ? this.provider.myApps : [];
    },
    profileName(){
      return this.provider && this.provider.info && this.provider.info.profileName ?
          this.provider.info.profileName : null;
    },
    siteURL(){
      return this.profileName ? `https://heartbeatfam.com/org/${this.profileName}`: null;
    }
  },
  created() {},
  mounted() {},
  methods: {
    setUpToggles() {
      this.toggles.forEach(aToggle => {
        if (this.settingsUser.hasOwnProperty(aToggle.property)) {
          aToggle.value = this.settingsUser[aToggle.property];
        }
      });
    },
    handleToggleChange(event) {
      //Maybe make top level
      let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        this.settingsUser[checkedId] = event.target.checked
            ? event.target.checked
            : false;
      }
      this.handleValueChange("careAreas", this.settingsUser);
    },
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    },
    profileBy() {
      return {
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname}`,
        imgURL: this.profile.imgURL
      };
    },
    handleGoToSite(){
      window.open(`https://dev.heartbeatfam.com/org/${this.profileName}`, "_blank");
      //window.open(`https://heartbeatfam.com/org/${this.profileName}`, "_blank");
    }
  },
  data() {
    return {
      modalIdResourcesBlocks: "block-resources-myapps",
      status: null, //|all | submitted | needs_work | inactive
      providerData: null,
      toggles: [
        {
          name: "intro",
          text: "Intro",
          description:"Basic Info goes Here-Maybe add image",
          property: "_hasIntro",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "about",
          text: "About",
          description: "About Goes Here",
          property: "_hasAbout",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "resources",
          text: "Resources",
          description: "Displays Resources- Automated",
          property: "_hasResources",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "sessions",
          text: "Sessions",
          description: "Display Event Sessions",
          property: "_hasSessions",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "iona",
          text: "Iona",
          description: "Display Iona",
          property: "_hasIona",
          type: "btns",
          isAvail: true,
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
.app_details {
  margin-top: 16px;
  font-family: "Nunito", sans-serif;
  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;

    color: #474d52;
  }
  .transactions {
    margin-top: 10px;
    margin-bottom: 20px;
    @media (max-width: 420px) {
      flex-direction: column;
      align-items: center;
    }
    h5 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      display: flex;
      align-items: center;

      color: #8d99a0;
      margin: 0;
    }
    .transaction_details {
      display: flex;
      align-items: center;
      @media (max-width: 600px) {
        flex-wrap: wrap;
      }
      @media (max-width: 420px) {
        flex-direction: column;
        align-items: center;
      }
      h6 {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        display: flex;
        margin-bottom: 0;
        align-items: center;
        color: #8d99a0;
        justify-content: center;
        margin-right: 38px;
        width: 120px;
        @media (max-width: 530px) {
          margin-right: 28px;
        }
        @media (max-width: 420px) {
          margin-right: 0px;
        }
      }
      .date_btn {
        cursor: pointer;
        position: relative;
        max-width: 224px;
        width: 100%;
        height: 35px;
        background: #f3f6f9;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #474d52;
        line-height: 35px;
        &:hover {
          background: rgba(85, 126, 251, 0.1);
        }
        @media (max-width: 420px) {
          margin-bottom: 10px;
          padding: 0 10px;
        }

        .calender {
          padding-right: 12px;
        }
        .down {
          padding-left: 12px;
        }
      }
      .email_btn,
      .download_btn {
        background: rgba(85, 126, 251, 0.1);
        border-radius: 4px;
        // max-width: 87px;
        // width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        color: var(--theme-color);
        padding-left: 10px !important;
        padding-right: 10px;
        border: none;
        margin-left: 12px;
        &.download {
          max-width: 120px;
          &:hover {
            background: rgba(85, 126, 251, 0.1) !important;
          }
        }
        @media (max-width: 530px) {
          margin-left: 0px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
        span {
          padding-right: 8px;
        }
        &:focus {
          outline: none;
          border: none;
        }
      }
      .download_btn {
        // max-width: 89px;
        height: 43px;
        width: 100%;
        // justify-content: flex-start;
        background: none;
        @media (max-width: 530px) {
          margin-left: 70px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
      }
    }
  }
  .app_list {
    //max-width: 915px;
    font-family: "Nunito", sans-serif;
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    margin-top: 20px;
    filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
    border-radius: 8px;
  }
}
</style>
